// extracted by mini-css-extract-plugin
export default {"home-card":"Home_home-card__MFDnq","profile":"Home_profile__K-i0H"};